import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import AdminConsole from "@/pages/AdminConsole";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import Bookings from "@/pages/Bookings";
import Tables from "@/pages/Tables";
import Menu from "@/pages/Menu";
import CallLogs from "@/pages/CallLogs";
import Usage from "@/pages/Usage";
import Settings from "@/pages/Settings";
import CashDrawer from "@/pages/CashDrawer";
import Website from "@/pages/Website";
import PublicSite from "@/pages/PublicSite";
import POS from "@/pages/POS";
import Kitchen from "@/pages/Kitchen";

const R = (Page) => (
  <ProtectedRoute>
    <Layout>
      <Page />
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["PLATFORM_ADMIN"]}>
                  <AdminConsole />
                </ProtectedRoute>
              }
            />
            <Route path="/r/:rid/dashboard" element={R(Dashboard)} />
            <Route path="/r/:rid/orders" element={R(Orders)} />
            <Route path="/r/:rid/bookings" element={R(Bookings)} />
            <Route path="/r/:rid/tables" element={R(Tables)} />
            <Route path="/r/:rid/menu" element={R(Menu)} />
            <Route path="/r/:rid/calls" element={R(CallLogs)} />
            <Route path="/r/:rid/usage" element={R(Usage)} />
            <Route path="/r/:rid/cash" element={R(CashDrawer)} />
            <Route path="/r/:rid/website" element={R(Website)} />
            <Route path="/r/:rid/settings" element={R(Settings)} />
            <Route path="/r/:rid/pos" element={<ProtectedRoute><POS /></ProtectedRoute>} />
            <Route path="/r/:rid/kitchen" element={<ProtectedRoute><Kitchen /></ProtectedRoute>} />
            <Route path="/site/:rid" element={<PublicSite />} />
            <Route path="/s/:slug" element={<PublicSite />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors duration={2500} />
    </div>
  );
}

export default App;
